import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { UtilsService } from 'src/app/utils/utils.service';
import { async, delay } from 'q';
import * as Highcharts from 'highcharts';
import { ProjConstants } from 'src/app/utils/proj.constant';

declare var require: any;
let Boost = require('highcharts/modules/boost');
let noData = require('highcharts/modules/no-data-to-display');
let More = require('highcharts/highcharts-more');

Boost(Highcharts);
noData(Highcharts);
More(Highcharts);
noData(Highcharts);

@Component({
  selector: 'app-thumbnail',
  templateUrl: './thumbnail.component.html',
  styleUrls: ['./thumbnail.component.scss']
})
export class ThumbnailComponent implements OnInit {
  chartData: any;
  popUpData: any;
  date: any;
  time: any;
  hours: any;
  minutes: any;
  seconds: any;
  AmOrPm: string;
  showDateTime: any;
  options: any;
  showChart: any;
  closeChart: boolean;
  yAxisMin: any;
  chartTableData: any;
  showDiv: any;
  forecastLength: any;
  forecastLengthSubscription: any;
  @Output() locNameData: EventEmitter<object> = new EventEmitter<object>();
  constructor(private router: Router, private http: HttpClient, private route: ActivatedRoute,
    private utils: UtilsService) {
    this.chartData = [];
    this.showDateTime = true;
    this.closeChart = true;
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

      }
    });
  }

  delay(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  async ngOnInit() {
    this.utils.getPopUpData().subscribe(async data => {
      this.popUpData = data;
      this.getDate();
      await delay(5000);
      this.showDateTime = false;
      let obj = {};
      if (this.popUpData) {
        obj['City'] = this.popUpData['City'];
        obj['State'] = this.popUpData['State'];
        this.locNameData.emit(obj);
      }
    });
    this.utils.getSearchBarChartData().subscribe(async data => {
      if (data) {
        this.closeChart = false;
        this.chartData = this.prepareChartData(data);
        this.setChartOptions();
        Highcharts.chart('container', this.options);
      }
    });
    this.utils.getBottomBarClosed().subscribe(value => {
      this.showDiv = value;
      if (this.showDiv) {
        this.chartTableData = {};
      }
    });
    this.forecastLengthSubscription = this.utils.getForecastLengthChanged().subscribe(value => {
      if (value == null) {
        this.forecastLength = this.router.url.split('/')[3];
      } else {
        this.forecastLength = value;
      }
    });
  }

  getDate() {
    this.date = new Date();
    if (this.date.getMinutes() < 10) {
      this.time = this.date.getHours() + ":0" + this.date.getMinutes();
    } else {
      this.time = this.date.getHours() + ":" + this.date.getMinutes();
    }
    if (this.date.getHours() >= 12) {
      this.AmOrPm = 'PM';
    } else {
      this.AmOrPm = 'AM';
    }
  }

  setChartOptions() {
    this.options = {
      credits: {
        enabled: false
      },
      chart: {
        height: 120,
        type: 'areaspline',
        backgroundColor: 'transparent'
      },
      title: {
        text: ''
      },
      xAxis: {
        visible: false
      },
      yAxis: {
        min: this.yAxisMin,
        visible: false,
      },
      plotOptions: {
        series: {
          fillColor: {
            linearGradient: [0, 0, 0, 80],
            stops: [
              [0, Highcharts.getOptions().colors[3]],
              [1, Highcharts.color(Highcharts.getOptions().colors[3]).setOpacity(0.2).get('rgba')]
            ]
          },
          lineWidth: 1,
          color: 'rgba(157, 141, 154, 0.25)'
        }
      },
      series: [
        {
          showInLegend: false,
          data: this.chartData
        }
      ]
    };
  }

  closeChartTab() {
    this.closeChart = true;
  }

  prepareChartData(data) {
    let temperatureChartData = {};
    for (let i = 0; i < 4; i++) {
      let component;
      let timestamps = Object.keys(data[i]);
      for (let ts of timestamps) {
        if (ts == "Component") {
          component = data[i][ts];
          temperatureChartData[component] = [];
        } else if (component == "TEMPERATURE") {
          let val = data[i][ts];
          val = val.split("(")[0];
          let obj = {};
          obj["timestamp"] = ts;
          obj["temperature"] = Number(val);
          temperatureChartData[component].push(obj);
        } else if (component != "TEMPERATURE") {
          let val = data[i][ts];
          temperatureChartData[component].push(Number(val));
        }
      }
    }

    let min = ProjConstants.MAX_INT;
    for (let number of temperatureChartData["TEMPERATURE"]) {

      if (Number(number["temperature"]) < min) {
        min = Number(number["temperature"]);
      }
    }

    this.yAxisMin = min;
    this.chartTableData = this.prepareChartTableData(temperatureChartData["TEMPERATURE"]);
    let temperatureArray = [];
    for (let value of temperatureChartData["TEMPERATURE"]) {
      temperatureArray.push(value["temperature"]);
    }
    return temperatureArray;
  }

  prepareChartTableData(data) {
    let temperatureValues = [];

    if (this.forecastLength == '24') {
      let greatest = {};
      let index = 1;
      greatest["temperature"] = -100;
      greatest["timestamp"] = '';
      while (index <= data.length) {
        if (index % 4 == 0) {
          let obj = {};
          Object.assign(obj, greatest);
          temperatureValues.push(obj);
          greatest["temperature"] = -100;
          greatest["timestamp"] = '';
        }
        if (data[index - 1]["temperature"] > greatest["temperature"]) {
          Object.assign(greatest, data[index - 1]);
        }
        index++;
      }
      if (data.length % 4 != 0) {
        temperatureValues.push(greatest);
      }
    } else if (this.forecastLength == '10') {
      let index = 1;
      while (index <= data.length) {
        temperatureValues.push(data[index - 1]);
        index++;
      }
    }

    // sort all data based on timestamp
    temperatureValues = this.bubbleSort(temperatureValues);
    for (let value of temperatureValues) {
      value["timestamp"] = this.getDay(value["timestamp"]);
    }
    return temperatureValues;
  }

  getDayfromNumber(num) {
    switch (num) {
      case 0: return 'Sun';
        break;
      case 1: return 'Mon';
        break;
      case 2: return 'Tue';
        break;
      case 3: return 'Wed';
        break;
      case 4: return 'Thu';
        break;
      case 5: return 'Fri';
        break;
      case 6: return 'Sat';
        break;
    }
  }

  getDay(timestamp) {
    var date = new Date(Number(timestamp));
    return this.getDayfromNumber(date.getDay());
  }

  bubbleSort(temperatureValues) {
    for (let index = 0; index < temperatureValues.length; index++) {
      for (let index1 = 0; index1 < temperatureValues.length - 1; index1++) {

        if (Number(temperatureValues[index1]["timestamp"]) > Number(temperatureValues[index1 + 1]["timestamp"])) {
          let swap = temperatureValues[index1];
          temperatureValues[index1] = temperatureValues[index1 + 1];
          temperatureValues[index1 + 1] = swap;
        }
      }
    }
    return temperatureValues;
  }
}